import { Button } from "~/components/Button";
import { Card, CardContent, CardHeader, CardTitle } from "~/components/card";
import { useAuth } from "~/contexts/auth";

export function SessionExpired() {
  const { status } = useAuth();

  if (status !== "expired") {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Loading...</CardTitle>
        </CardHeader>
      </Card>
    );
  }

  return (
    <Card role="alert">
      <CardHeader>
        <CardTitle>Session Expired</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <p className="text-gray-600">
            Your session has expired. Please log in to continue.
          </p>
          <Button onClick={() => (window.location.href = "/auth/google")}>
            Login Now
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
